import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import { createRef, PureComponent } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import ClassNotes from "./ClassNotes";
import Timestamp from "./Timestamp";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProgressBar = /*#__PURE__*/function (_PureComponent) {
  function ProgressBar(props) {
    var _this;
    _classCallCheck(this, ProgressBar);
    _this = _callSuper(this, ProgressBar, [props]);
    // Ref to the root progress element
    _this.progressRef = /*#__PURE__*/createRef();
    _this.removeMouseListener = function () {
      var hasMouseListener = _this.state.hasMouseListener;
      if (hasMouseListener) {
        _this.setState({
          hasMouseListener: false
        });
        window.removeEventListener('mousemove', _this.onMouseMove, true);
      }
    };
    _this.onMouseUp = function () {
      _this.setState({
        isClicked: false
      });
      _this.removeMouseListener();
    };
    _this.onTouchEnd = function () {
      _this.setState({
        isClicked: false
      }, function () {
        window.removeEventListener('touchmove', _this.onTouchMove, true);
      });
    };
    _this.onBlur = function () {
      if (_this.props.disableSeekForward) {
        return;
      }
      var isClicked = _this.state.isClicked;
      if (!isClicked) {
        _this.setState({
          isHovered: false
        });
        _this.removeMouseListener();
      }
    };
    _this.onHandlePositionChange = function (clientX) {
      var _this$props = _this.props,
        seek = _this$props.seek,
        duration = _this$props.duration;
      if (_this.progressRef.current && document) {
        var bodyRect = document.body.getBoundingClientRect();
        var progressRect = _this.progressRef.current.getBoundingClientRect();
        var progressOffset = progressRect.left - bodyRect.left;
        var mousePosition = clientX - progressOffset;
        var newProgress = mousePosition / _this.progressRef.current.clientWidth;
        var newTime = newProgress * duration;
        _this.setState(function (prevState) {
          if (prevState.isClicked) {
            seek(newTime);
          }
          return {
            hoveredTime: newTime
          };
        });
      }
    };
    _this.onMouseMove = function (e) {
      _this.onHandlePositionChange(e.clientX);
    };
    _this.onTouchMove = function (e) {
      var _e$changedTouches$;
      var clientX = (_e$changedTouches$ = e.changedTouches[0]) === null || _e$changedTouches$ === void 0 ? void 0 : _e$changedTouches$.clientX;
      if (clientX) {
        _this.onHandlePositionChange(clientX);
      }
    };
    _this.onTouchStart = function (e) {
      var _e$changedTouches$2;
      if (_this.props.disableSeekForward) {
        return;
      }
      var clientX = (_e$changedTouches$2 = e.changedTouches[0]) === null || _e$changedTouches$2 === void 0 ? void 0 : _e$changedTouches$2.clientX;
      _this.setState({
        isClicked: true
      }, function () {
        if (clientX) {
          _this.onHandlePositionChange(clientX);
        }
        window.addEventListener('touchmove', _this.onTouchMove, true);
      });
    };
    _this.addMouseListener = function (clientX) {
      var hasMouseListener = _this.state.hasMouseListener;
      _this.onHandlePositionChange(clientX);
      if (!hasMouseListener) {
        _this.setState({
          hasMouseListener: true
        });
        window.addEventListener('mousemove', _this.onMouseMove, true);
      }
    };
    _this.onMouseDown = function (e) {
      if (_this.props.disableSeekForward) {
        return;
      }
      var clientX = e.clientX;
      _this.setState({
        isClicked: true
      }, function () {
        _this.addMouseListener(clientX);
      });
    };
    _this.onHover = function (e) {
      if (_this.props.disableSeekForward) {
        return;
      }
      var clientX = e.clientX;
      _this.setState({
        isHovered: true
      }, function () {
        _this.addMouseListener(clientX);
      });
    };
    _this.onFocus = function () {
      if (_this.props.disableSeekForward) {
        return;
      }
      _this.setState({
        isHovered: true
      });
    };
    _this.state = {
      hasMouseListener: false,
      isHovered: false,
      isClicked: false,
      hoveredTime: 0
    };
    return _this;
  }
  _inherits(ProgressBar, _PureComponent);
  return _createClass(ProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined' && !this.props.disableSeekForward) {
        window.addEventListener('mouseup', this.onMouseUp, true);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var _this$props2 = this.props,
        onSeek = _this$props2.onSeek,
        currentTime = _this$props2.currentTime,
        disableSeekForward = _this$props2.disableSeekForward;
      if (!this.state.isClicked && prevState.isClicked && onSeek && !disableSeekForward) {
        onSeek(currentTime);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mousemove', this.onMouseMove, true);
        window.removeEventListener('mouseup', this.onMouseUp, true);
        window.removeEventListener('touchmove', this.onTouchMove, true);
        window.removeEventListener('touchend', this.onTouchEnd, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        currentProgress = _this$props3.currentProgress,
        duration = _this$props3.duration,
        bufferedRanges = _this$props3.bufferedRanges,
        classNotes = _this$props3.classNotes,
        playerSize = _this$props3.playerSize,
        visibleUi = _this$props3.visibleUi,
        disableSeekForward = _this$props3.disableSeekForward;
      var _this$state = this.state,
        isHovered = _this$state.isHovered,
        isClicked = _this$state.isClicked,
        hoveredTime = _this$state.hoveredTime;
      var barSizeClassName = playerSize.matches.md ? 'h-8' : 'h-4';
      return /*#__PURE__*/_jsxs("div", {
        ref: this.progressRef,
        className: cn('cp-progress relative w-full flex items-center z-1', visibleUi ? 'cursor-pointer' : 'cursor-none', playerSize.matches.md ? 'h-16' : 'h-12 pb-8 pt-16'),
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseOver: this.onHover,
        onFocus: this.onFocus,
        onMouseLeave: this.onBlur,
        children: [/*#__PURE__*/_jsx("div", {
          className: cn('absolute left-0 w-full bg-base-lighter-70 -z-1', barSizeClassName)
        }), bufferedRanges.map(function (range) {
          return /*#__PURE__*/_jsx(_StyledDiv, {
            className: cn('absolute bg-gray-main z-0', barSizeClassName),
            style: {
              width: "".concat((range.end - range.start) / duration * 100, "%"),
              left: "".concat(range.start / duration * 100, "%")
            }
          }, "buffer-range-".concat(range.start));
        }), /*#__PURE__*/_jsx(_StyledDiv2, {
          className: cn('absolute left-0 bg-secondary-light z-1', barSizeClassName),
          style: {
            width: "".concat(currentProgress * 100, "%")
          }
        }), /*#__PURE__*/_jsx(_StyledDiv3, {
          className: cn('absolute left-0 z-2', barSizeClassName),
          style: {
            width: "".concat(currentProgress * 100, "%")
          },
          children: !disableSeekForward && /*#__PURE__*/_jsx("div", {
            className: cn('absolute w-12 h-12 bg-secondary-light rounded-full', playerSize.matches.md ? 'w-16 h-16' : 'w-12 h-12'),
            style: {
              right: playerSize.matches.md ? '-8px' : '-6px',
              bottom: '-4px'
            }
          })
        }), duration && playerSize.matches.md && /*#__PURE__*/_jsx(Timestamp, {
          hoveredTime: hoveredTime,
          visible: isHovered || isClicked,
          progressWidth: this.progressRef.current ? this.progressRef.current.clientWidth : 0
        }), playerSize.matches.md && !!(classNotes !== null && classNotes !== void 0 && classNotes.length) && /*#__PURE__*/_jsx(ClassNotes, {
          classNotes: classNotes
        })]
      });
    }
  }]);
}(PureComponent);
export default ProgressBar;
var _StyledDiv = /*#__PURE__*/_styled("div")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n              transition: ", ";\n            "])), function (_ref) {
  var theme = _ref.theme;
  return theme.transition('width');
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div")(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteral(["\n            transition: ", ";\n          "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition('width');
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div").withConfig({
  componentId: "sc-ut7zmr-0"
})(["\n            transition: ", ";\n          "], function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition('width');
});